"use client";
import React, { Suspense } from "react";
import { Box, Separator, VStack } from "@chakra-ui/react";
import Tabs from "@/components/tabs";
import PricingFooter from "@/components/pricingFooter";
import { Heading } from "@/elements";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import { PRICING_HEADING_CONSTANTS, FOOTER_CONSTANTS } from "./constants";
import { tablist } from "./pricingTabsList";
import PlanFeatures from "./features";
import AuditBundles from "./auditBundles";

const Microsoft365Pricing = () => {
  const headingVariant = useHeadingVariant();
  return (
    <VStack id="pricing" gap={6}>
      <Heading as="h1" variant={headingVariant}>
        {PRICING_HEADING_CONSTANTS.title}
      </Heading>
      <Suspense>
        <Tabs columns={{ base: 1, sm: 2 }} tabList={tablist} />
      </Suspense>
      <Box w="full">
        <PlanFeatures />
        <AuditBundles />
        <PricingFooter {...FOOTER_CONSTANTS} />
      </Box>
      <Separator borderWidth="2px" borderColor="#ECECEC" my={10} />
    </VStack>
  );
};

export default Microsoft365Pricing;
